// import {Howl} from 'howler';

export class StoryPageWord {

    DOMElement: HTMLElement;
    audioPath: string;
    // duration: number; // YA211004 added to store the duration on the fly during population
}